export default __webpack_public_path__ + "MRt_msgEvents.html";